"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    backgroundColor: "#eee",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "50%",
    marginLeft: "-50%",
    overflow: "hidden",
    transition: ".25s ease-out",
    "& + *": {
      transition: ".25s ease-out"
    },
    "&[aria-expanded=true]": {
      marginLeft: 0,
      "& + *": {
        marginLeft: "50%"
      }
    }
  }
}));

const EditorSidebar = ({
  className,
  expanded,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("aside", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, children);
};

var _default = EditorSidebar;
exports.default = _default;
module.exports = exports.default;